// Handles sticky/positioned summary div adjustment on scroll
export function initProductSummary({ summaryDiv }) {
    if (!summaryDiv) return;
    let scrollTicking = false;
    function onScroll() {
        if (!scrollTicking) {
            window.requestAnimationFrame(() => {
                adjustSummaryDivPosition(summaryDiv);
                scrollTicking = false;
            });
            scrollTicking = true;
        }
    }
    window.addEventListener('scroll', onScroll);
}

function adjustSummaryDivPosition(summaryDiv) {
    const windowHeight = window.innerHeight;
    const scrollPosition = window.scrollY;
    const summaryHeight = summaryDiv.offsetHeight;
    let newTop = Math.max(0, windowHeight - scrollPosition);
    newTop = Math.min(newTop, windowHeight - summaryHeight);
    summaryDiv.style.top = `${newTop}px`;
}
